import React, { FC, ReactNode, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './styles/dropdown_pricing_button.module.scss';
import { Hyperlink } from '../../components/Hyperlink';
import { useUser } from '../../user/useUser';
import { BrandButton } from '../../components/button';

type Props = {
  children: ReactNode;
  noHover: Boolean;
};

export const DropdownPricingButton: FC<Props> = ({ children, noHover }) => {
  const {
    currentUser: { daysRemaining, plan },
  } = useUser();
  const [hovered, setHovered] = useState(false);

  const toggleDisplay = () => {
    setHovered((prevHover) => !prevHover);
  };

  const conditionalSentence = (number: number) => {
    if (number === 0)
      return (
        <FormattedMessage id="pricing-button/DropdownPricingButton.tsx/1" />
      );
    return (
      <FormattedMessage
        id="pricing-button/DropdownPricingButton.tsx/2"
        values={{ number }}
      />
    );
  };

  const label = conditionalSentence(daysRemaining);

  const hasDaysRemaining = !plan;

  if (!hasDaysRemaining) return null;

  return (
    <Hyperlink
      className={styles.wrapper}
      href="/tarifs"
      source="nav"
      onMouseEnter={toggleDisplay}
      onMouseLeave={toggleDisplay}
    >
      <BrandButton>{label}</BrandButton>
      {hovered && !noHover && (
        <span className={styles.secret}>
          <div className={styles.container}>
            <div className={styles.inside}>{children}</div>
          </div>
        </span>
      )}
    </Hyperlink>
  );
};
